<div class="login-page">
  <header class="login-header">
    <a class="login-brand" [routerLink]="['/app/inicio']" aria-label="Vabait, volver al inicio">
      <img src="../../../assets/images/logo-valorinmobiliaria.png" alt="Vabait Inmobiliaria">
    </a>
    <a class="login-back" [routerLink]="['/app/inicio']">
      <i class="bi bi-arrow-left" aria-hidden="true"></i>
      <span>Volver al sitio</span>
    </a>
  </header>

  <main class="login-content">
    <div class="row login-row">
      <div class="col-lg-7 mx-auto">
        <div class="login-form-wrapper px-md-5 px-4">
          <h1 class="modal-title text-center mb-3">Iniciar sesión</h1>
          <p class="font-size-sm text-muted text-center">Accede a tu cuenta de Vabait</p>
         <form #loginForm="ngForm" (ngSubmit)="login(loginForm)" >
           <div class="form-group mt-3">
             <label for="signin-email">Correo electrónico</label>
             <input type="email" class="form-control" name="email" autocomplete="username" [(ngModel)]="user.email" placeholder="Tú Correo" required="">
           </div>
             <div class="form-group mt-3">
                 <label for="signin-password" class="form-label">Contraseña</label>
                 <div class="cs-password-toggle input-group-overlay">
                 <input [type]="fieldTextType ? 'text' : 'password'" class="form-control appended-form-control" name="password" autocomplete="current-password" [(ngModel)]="user.password"  placeholder="Tú contraseña" required>
                 <div class="input-group-append-overlay">
                     <label class="btn cs-password-toggle-btn input-group-text">
                     <input type="checkbox" class="custom-control-input">
                     <i class="" [ngClass]="{'bi bi-eye-slash-fill': !fieldTextType,
                                              'bi bi-eye-fill':fieldTextType  }"  (click)="showPassword()" ></i>
                     <span class="sr-only">Mostrar contraseña</span>
                     </label>
                 </div>
                 </div>
             </div>

             <div class="login-remember">
                 <input id="remember-user" type="checkbox" name="recordarUsuario" [(ngModel)]="recordarUsuario">
                 <label for="remember-user">Recordarme en este dispositivo</label>
             </div>

           <button type="submit" class="btn btn-primary btn-block btn_iniciar mt-3" [disabled]="isSubmitting" [attr.aria-busy]="isSubmitting">
             <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
             <span>{{ isSubmitting ? 'Ingresando...' : 'Ingresar' }}</span>
           </button>
           <p class="login-status" role="status" aria-live="polite" *ngIf="isSubmitting">Estamos validando tus datos. Espera un momento.</p>

          </form>
          </div>
        </div>
    </div>
      </main>
</div>
